<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="关键字：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'goodsSearchLogEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                title: '',
                order_index: '',
            },
            getObj:{
                url:'/api/admin/goodssearchlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                title: [
                    {required: true, message: '关键字不能为空', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/goodssearchlog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>